import { InputNumber } from "antd";
import { changeStock, changeWeight } from "app/slices/add-update-product/AddAndUpdateProduct";
import { useDispatch } from "react-redux";

interface IStockInput {
    value: any;
}

const StockInput = (props: IStockInput) => {
    const { value } = props;
    const dispatch = useDispatch();

    return (
        <InputNumber
            placeholder={"Tồn kho"}
            value={!value?.value ? 0 : value?.value}
            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
            onChange={(text) => {
                dispatch(
                    changeStock({
                        key: value.id,
                        stock: text,
                    })
                );
            }}
            style={{ width: 150 }}
            onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                }
            }}
        />
    );
};

export default StockInput;
